import { Component, inject, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { DocumentIcon } from '@sportello-balneari/shared-components';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { detectFileTypeFromExtension } from '../../../common/various-functions/detect-file-type-from-extension.function';
import { CompilingWidgetService } from '../../../services/compiling/widget.service';
import { FileDialogCustomization } from './filedialog-edit';

@Component({
  selector: 'lib-filedialog-compiled',
  standalone: true,
  imports: [
    MatIconModule,
    TooltipModule,
    ButtonModule,
    TableModule,
    DocumentIcon,
  ],
  template: `
    @let widget = widgetService.widget();
    @if (widget) {
      @let files = this.widgetService.formControl()?.value ?? [];

      <p-table
        [value]="files"
        [paginator]="files.length > 0"
        [rows]="5"
        [showCurrentPageReport]="false"
        class="w-full"
      >
        <ng-template pTemplate="header">
          <tr>
            <th>Documenti</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item let-index="rowIndex">
          <tr>
            <td>
              <div class="flex flex-1 items-center gap-3">
                <div class="flex items-center gap-3">
                  <lib-document-icon [fileName]="item.fileName" />
                  <span class="flex flex-1 grow font-semibold text-slate-900">{{
                    item.fileName
                  }}</span>
                </div>
                <div class="ml-auto flex">
                  <p-button
                    icon="pi pi-download"
                    [text]="true"
                    [rounded]="true"
                    severity="secondary"
                    pTooltip="Scarica documento"
                    tooltipPosition="left"
                  ></p-button>
                </div>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template #emptymessage>
          <tr>
            <td colspan="3">Nessun file caricato</td>
          </tr>
        </ng-template>
      </p-table>
    }
  `,
  styleUrls: ['../style.css'],
})
export class FileDialogCompiledComponent {
  protected widgetService = inject(
    CompilingWidgetService<FileDialogCustomization>,
  );

  protected files = signal<File[] | undefined>(undefined);

  fixType(data: string) {
    return data.split('.').pop() || 'unknown';
  }

  detectExtension(
    data: string,
    type: 'pdf' | 'word' | 'excel' | 'image' | 'txt',
  ) {
    return detectFileTypeFromExtension(data, type);
  }
}
